export default __webpack_public_path__ + "static/media/highest-level-of-service.386fbc1a.png";